module.exports = {
      id: "arrow-left-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }